import {FormEditor} from "@t/fd/editor/FormEditor.ts";

export const COLOR_NAMES = ["unset", "red","orange","yellow","light-green","dark-green",
	"green-blue","cyan","blue","dark-blue","purple","magenta","salmon"];

export interface EventColor extends FormEditor {
	type: "eventcolor";
}

export const DEFAULT_EVENT_COLOR = 3;	// Yellow
